import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const TestimonialService = {
  getList: async () => {
    const response = await apiService.get("/testimonials");
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/testimonials/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(`/testimonials/slug?slug=${id}`);
    return response.data;
  },
};

export default TestimonialService;
